// extracted by mini-css-extract-plugin
module.exports = {"YSWYWContent":"YSWYWContent_1k6b","subtitle":"subtitle_2Yjz"};